<div class="max-w-2xl mx-auto mt-8 p-6 rounded-lg border border-gray-300">
  <h2 class="titre2">{{ 'USERS_MANAGEMENT.EDIT_USER' | translate }}</h2>
  @if (isLoading) {
    <mat-spinner class="mx-auto" color="accent"></mat-spinner>
  }
  @if (!isLoading && user) {
    <div>
      <div class="mb-4">
        <div class="mb-4">
          <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.NAME' | translate
          }}:</span>
          <label class="mt-1 block w-full rounded-md bg-gray-700 shadow-sm p-2">
            {{ user.estInvitationEnAttente ? ('USERS_MANAGEMENT.PENDING_INVITATION' | translate) : user.nom }}
          </label>
        </div>
        <div class="mb-4">
          <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.EMAIL' | translate
          }}:</span>
          <label class="mt-1 block w-full rounded-md  shadow-sm bg-gray-700 p-2">
            {{ user.email }}
          </label>
        </div>
        <div class="mb-4">
          <label for="numeroEmploye" class="block text-sm font-medium mb-1">{{
          'USERS_MANAGEMENT.EMPLOYEE_NUMBER' | translate }}:</label>
          <input type="text" id="numeroEmploye" [value]="numeroEmploye" (input)="onNumeroEmployeChange($event)"
            class="mt-1 block w-full rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50">
          </div>
          <div class="mb-4">
            <span class="block text-sm font-medium  mb-1">{{ 'USERS_MANAGEMENT.ROLE' | translate
            }}</span>
            <div class="flex flex-col space-y-2">
              @if (utilisateurService.entiteUtilisateurSelectionnee.utilisateurId != utilisateurId) {
                @if (estPiloteGroupe) {
                  <div class="flex items-center">
                    <input type="checkbox" id="estPilote" (change)="onRoleChange('pilote')"
                      class="form-checkbox h-5 w-5  rounded mr-2 focus:outline-none focus:ring-0"
                      [(ngModel)]="estPilote">
                      <label for="estPilote">{{ 'USERS_MANAGEMENT.PILOT' | translate }}</label>
                    </div>
                  }
                  <div class="flex items-center">
                    <input type="checkbox" id="estAdmin" (change)="onRoleChange('admin')"
                      class="form-checkbox h-5 w-5 rounded mr-2 focus:outline-none focus:ring-0"
                      [(ngModel)]="estAdmin">
                      <label for="estAdmin">{{ 'USERS_MANAGEMENT.ADMINISTRATOR' | translate }}</label>
                    </div>
                    @if (estAdmin && entitesAccessibles.length === 1) {
                      <span class="block mb-2">{{ 'USERS_MANAGEMENT.ADMIN_COMPANY' | translate }}: {{
                      entitesAccessibles[0].nom }}</span>
                    }
                    @if (estAdmin && entitesAccessibles.length > 1) {
                      <div class="ml-6 mt-2">
                        @if (entitesDispoAdmin.length > 0) {
                          <select title="entite"
                            [(ngModel)]="entiteIdAdminSelectionnee" (change)="onEntiteAdminSelected($event)"
                            class="w-full p-2 border rounded">
                            <option [ngValue]="-1">{{ 'USERS_MANAGEMENT.SELECT_COMPANY' | translate }}</option>
                            @for (entite of entitesDispoAdmin; track entite) {
                              <option [value]="entite.id">{{ entite.nom }}
                              </option>
                            }
                          </select>
                        }
                        @if (entiteAdmins.length > 0) {
                          <div class="mt-3">
                            <h4 class="titre4">{{ 'USERS_MANAGEMENT.SELECTED_ENTITIES' | translate }}:</h4>
                            <ul class="list-disc list-inside">
                              @for (entite of entiteAdmins; track entite) {
                                <li>
                                  {{ entite.nom }}
                                  <button (click)="removeSelectedEntity(entite.id)" class="ml-2 text-rougeNovo">{{
                                  'USERS_MANAGEMENT.REMOVE' | translate }}</button>
                                </li>
                              }
                            </ul>
                          </div>
                        }
                      </div>
                    }
                  }
                  @if (estPiloteGroupe || (estAdmin && entitesAccessibles.length > 1)) {
                    <div class="mb-4">
                      <label for="entiteVisionnement" class="block mb-2">{{ 'USERS_MANAGEMENT.VIEWING_ENTITY' |
                      translate }}</label>
                      <select id="entiteVisionnement" [ngModel]="entiteIdVisioSelectionne"
                        (ngModelChange)="onEntiteVisionnementChange($event)" class="w-full p-2 border rounded">
                        <option [ngValue]="null">{{ 'USERS_MANAGEMENT.SELECT_ENTITY' | translate }}</option>
                        @for (entite of entitesVisionnement; track entite) {
                          <option [value]="entite.id">{{ entite.nom }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                </div>
              </div>
              <div class="mb-4">
                <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.TAGS' | translate
                }}</span>
                <select title="TAGS" id="etiquettes" [(ngModel)]="etiquetteIdSelectionnee"
                  (change)="onEtiquetteSelected($event)" class="w-full p-2 border rounded">
                  <option [ngValue]="null">{{ 'USERS_MANAGEMENT.SELECT_TAG' | translate }}</option>
                  @for (etiquette of etiquettesDisponibles; track etiquette) {
                    <option [value]="etiquette.etiquetteId">
                      {{ etiquetteService.getNomLocalise(etiquette.locales)}}
                    </option>
                  }
                </select>
                @if (etiquettesSelectionnees.length > 0) {
                  <div class="mt-3">
                    <h4 class="font-semibold">{{ 'USERS_MANAGEMENT.SELECTED_TAGS' | translate }}:</h4>
                    <ul class="list-disc list-inside">
                      @for (etiquette of etiquettesSelectionnees; track etiquette) {
                        <li>
                          {{ etiquetteService.getNomLocalise(etiquette.locales)}} <button
                          (click)="removeSelectedEtiquette(etiquette.etiquetteId)" class="ml-2 text-rougeNovo">
                          {{ 'USERS_MANAGEMENT.REMOVE' | translate }}
                        </button>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          </div>
          <div class="flex justify-end">
            <button type="button" (click)="router.navigate(['/utilisateurs-managment'])" class="btn-secondary-novo">
              {{ 'USERS_MANAGEMENT.CANCEL' | translate }}
            </button>
            <button type="submit" (click)="saveUser()"
              [disabled]="boutonSauvegardeDesactive() || estEnCoursDeEnregistrement"
              class="btn-primary-novo disabled:opacity-50 disabled:cursor-not-allowed">
              @if (!estEnCoursDeEnregistrement) {
                {{ 'USERS_MANAGEMENT.SAVE' | translate }}
              }
              @if (estEnCoursDeEnregistrement) {
                <mat-spinner diameter="20" class="inline-block"></mat-spinner>
              }
            </button>
          </div>
        </div>
      }
    </div>